import { Link } from 'react-router-dom';
import type { DocEntry } from '../../api/types';
import Tag from '../ui/Tag';
import Card from '../ui/Card';
import styles from './DocCard.module.css';

interface DocCardProps {
  doc: DocEntry;
  category: string;
}

export default function DocCard({ doc, category }: DocCardProps) {
  // slug format: "category/doc-slug" → extract the doc-slug part
  const docSlug = doc.slug.includes('/') ? doc.slug.split('/').slice(1).join('/') : doc.slug;
  return (
    <Link to={`/archive/${category}/${docSlug}`} className={styles.link}>
      <Card hoverable className={styles.card}>
        <div className={styles.meta}>
          <span className={styles.date}>
            {new Date(doc.date).toLocaleDateString('zh-CN', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          </span>
        </div>
        <h3 className={styles.title}>{doc.title}</h3>
        <p className={styles.summary}>{doc.summary}</p>
        <div className={styles.tags}>
          {doc.tags.slice(0, 3).map((tag) => (
            <Tag key={tag} variant="cyan" size="sm">{tag}</Tag>
          ))}
        </div>
        <div className={styles.arrow}>→</div>
      </Card>
    </Link>
  );
}
